import { nanoid } from "nanoid";
import { axiosClient } from "api/api";

export const getData = async (
  setIpAddressName,
  setPassword,
  setFormValue,
  formValue,
  setEmail,
  setFirstname,
  setLastName,
  searchParams
) => {
  try {
    // Fetch IP data
    const ipUrl = `/api/user/get-ip-details`;
    const ipResponse = await axiosClient.get(ipUrl, { timeout: 5000, });

    if (ipResponse?.data) {
      // Extract necessary data from the IP response
      const ipData = ipResponse?.data?.data || {};
      const ipAddress = ipData.ip;
      const language = ipData.country.language.name;
      const timeZone = ipData.time_zone;
      const country = ipData.country_name;
      const state = ipData.region_name;

      // Get referralBy from search params
      const referralBy = searchParams.get("referralBy") ? searchParams.get("referralBy") : "";
      const sessionId = searchParams.get("SESSION_ID") || "";
      const uid = searchParams.get("UID") || "";

      // Generate a random password
      const password = nanoid();

      // Update state with IP data
      // setIpAddressName(ipAddress);
      setPassword(password);
      setFormValue({
        ...formValue,
        language,
        timeZone,
        country,
        state,
        currentUrl: window.location.href,
        confirmPassword: password,
        email: setEmail,
        firstName: setFirstname,
        lastName: setLastName,
        referalId: referralBy,
        sessionId: sessionId,
        uid: uid
      });

      return {
        ipAddress,
        language,
        timeZone,
        country,
        state,
        password,
      };
    }
  } catch (error) {
    return null;

  }
};

export const getDataNew = async (
  setIpAddressName,
  setCountryName,
  setForm,
  form,
  searchParams,
) => {
  try {
    let ipData: any = null;
    // =========================
    // PRIMARY API (IP Registry)
    // =========================
    const ipUrl = `/api/user/get-ip-details`;
    const ipResponse = await axiosClient.get(ipUrl, { timeout: 5000, });
    if (ipResponse?.data) {
      const data = ipResponse?.data?.data;
      ipData = {
        ip: data.ip,
        language: data.country?.language?.name || "English",
        timeZone: data.time_zone || "",
        country: data.country_name || data.country?.name || "",
        state: data.region_name || "",
      };
    }
    if (!ipData) {
      ipData = {
        ip: "",
        language: "English",
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        country: "",
        state: "",
      };
    }

    const language = ipData.language;
    const timeZone = ipData.timeZone;
    const country = ipData.country;
    const state = ipData.state;

    // Update state
    setIpAddressName(ipData.ip);
    setCountryName(country);

    // URL Params
    const sid = searchParams.get("sid") || "";
    const clickid = searchParams.get("clickid") || "";
    const geo = searchParams.get("geo") || "";
    const referralBy = searchParams.get("referralBy") || "";
    const sessionId = searchParams.get("SESSION_ID") || "";
    const uid = searchParams.get("UID") || "";

    setForm((prev) => ({
      ...prev,
      language,
      timeZone,
      country,
      state,
      currentUrl: window.location.href,
      referalId: referralBy,
      sid,
      clickid,
      geo,
      sessionId,
      uid
    }));
  } catch (error) {
    console.log("getDataNew Error", error?.message);
  }
};

export const getCountry = async (
  setCountryName,
) => {
  // Fetch IP data
  const ipUrl = `/api/user/get-ip-details`;
  const ipResponse = await axiosClient.get(ipUrl, { timeout: 5000, });

  // Extract necessary data from the IP response
  const ipData = ipResponse?.data?.data || {};
  const country = ipData.country_name;

  // Update state with IP data
  setCountryName(country);
  return country;
};

export const getIpAddress = async (
  setIpAddressName,
) => {
  // Fetch IP data
  const ipUrl = `/api/user/get-ip-details`;
  const ipResponse = await axiosClient.get(ipUrl, { timeout: 5000, });

  // Extract necessary data from the IP response
  const ipData = ipResponse?.data?.data || {};
  const ipAddress = ipData.ip;

  // Update state with IP data  
  setIpAddressName(ipAddress);
  return ipAddress;
};

export const getIpAddressByIPify = async () => {
  try {
    const ipUrl = `/api/user/get-ip-details`;
    // fallback (IPv6)
    const ipResponse = await axiosClient.get(ipUrl, { timeout: 5000, });
    return ipResponse.data?.ip;
  } catch (err) {
    console.error("Both IPv4 and IPv6 fetch failed", err);
    return null;
  }
};

export const getCountryCode = async (
  setCountryCode,
) => {
  // Fetch IP data
  const ipUrl = `/api/user/get-ip-details`;
  const ipResponse = await axiosClient.get(ipUrl, { timeout: 5000, });

  // Extract necessary data from the IP response
  const ipData = ipResponse?.data?.data || {};
  const countryCode = ipData.country_code;

  // Update state with IP data
  setCountryCode(countryCode);
  return countryCode;
};